import { useState } from 'react';
import { SelectInput } from 'src/latest/src/components';
import onlineIcon from 'src/assets/icons/onlineIcon.svg';
import inpersonIcon from 'src/assets/icons/InpersonIcon.svg';
import onlineAndInperson from 'src/assets/icons/onlineAndInperson.svg';
import './AutocompleteDropdown.scss';
import { MeetingType } from 'src/latest/src/constants/MeetingTypeEnums';

const AutocompleteDropdown = ({
  type,
  index,
  filter,
  onFilterValueUpdated,
  className,
  disabled,
  isGrouped = false,
  checkbox: _checkbox,
}) => {
  const getSlotIcons = (slotReason, customClassName) => {
    if (
      slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.Online.toLowerCase()) &&
      !slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.OnlineOrInPerson.toLowerCase()) &&
      !slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.InPerson.toLowerCase())
    ) {
      return (
        <img src={onlineIcon} alt="onlineIcon" className={customClassName} />
      );
    }

    if (
      slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.InPerson.toLowerCase()) &&
      !slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.Online.toLowerCase()) &&
      !slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.OnlineOrInPerson.toLowerCase())
    ) {
      return (
        <img
          src={inpersonIcon}
          alt="inpersonIcon"
          className={customClassName}
        />
      );
    }

    if (
      slotReason
        .toString()
        .toLowerCase()
        .includes(MeetingType?.OnlineOrInPerson.toLowerCase())
    ) {
      return (
        <img
          src={onlineAndInperson}
          alt="onlineAndInperson"
          className={customClassName}
        />
      );
    }
  };

  const preferredGroupOrder = [
    'Commonly Selected Expertise',
    'Additional Expertise',
    'Conmmonly Selected Approaches',
    'Additional Approaches',
  ];

  const flatOptions = isGrouped
    ? filter.filter_selection_data
        .flatMap(el =>
          el.group.map(group => ({
            ...el,
            value: el.unique_key,
            title: el.label,
            group,
          })),
        )
        .sort(
          (a, b) =>
            preferredGroupOrder.indexOf(a.group) -
              preferredGroupOrder.indexOf(b.group) ||
            a.title.localeCompare(b.title),
        )
    : filter.filter_selection_data.map(el => ({
        ...el,
        value: el.unique_key,
        title: el.label,
      }));

  const options = isGrouped
    ? preferredGroupOrder
        .filter(g => flatOptions.some(o => o.group === g))
        .map(g => ({
          label: g,
          options: flatOptions.filter(o => o.group === g),
        }))
    : flatOptions;

  const defaultValue =
    type === 'multi-checkbox'
      ? Array.from(
          new Set(flatOptions.filter(o => o.selected).map(o => o.unique_key)),
        ).map(key => flatOptions.find(o => o.unique_key === key))
      : flatOptions.find(o => o.selected);

  const inputId = `select-${filter?.filter_key || index}`;

  const hasInitialValue =
    type === 'multi-checkbox'
      ? Array.isArray(defaultValue) && defaultValue.length > 0
      : Boolean(defaultValue);
  const [hasValue, setHasValue] = useState(hasInitialValue);

  const labelText = hasValue
    ? (filter?.filter_label || '').replace(/^all\s+/i, '')
    : filter?.filter_label;

  return (
    <div className={`floating-label-select ${className || ''}`}>
      <SelectInput
        key={inputId}
        inputId={inputId}
        isMulti={type === 'multi-checkbox'}
        isDisabled={disabled}
        isClearable={
          filter.filter_key !== 'serviceType' &&
          filter.filter_key !== 'insurancePlan' &&
          filter.filter_key !== 'ageGroup'
        }
        closeMenuOnSelect={type !== 'multi-checkbox'}
        hideSelectedOptions={false}
        className={`ca-filter-autocomplete ${className || ''}`}
        options={options}
        defaultValue={defaultValue}
        width="100%"
        menuZIndex={99}
        getOptionLabel={option => option.title}
        getOptionValue={option => option.unique_key}
        placeholder=""
        formatOptionLabel={(option, { context, selectValue }) => {
          if (context === 'menu') {
            const isSelected = selectValue.some(
              v => v.unique_key === option.unique_key,
            );

            return (
              <div className="d-flex align-items-center">
                {type === 'multi-checkbox' && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={e => e.preventDefault()}
                    style={{ marginRight: 8 }}
                  />
                )}
                {filter.filter_key === 'meetingPreference' &&
                  getSlotIcons(option.title, 'me-2')}
                <span>{option.title}</span>
              </div>
            );
          }

          if (filter.filter_key === 'meetingPreference') {
            return (
              <div className="d-flex align-items-center">
                {getSlotIcons(option.title, 'me-1 custom-icon-ml')}
                <span>{option.title}</span>
              </div>
            );
          }

          return <span>{option.title}</span>;
        }}
        formatGroupLabel={group => (
          <h6 className="group-header">{group.label}</h6>
        )}
        onChange={newValue => {
          let selectedWithOriginalGroups;

          if (type === 'multi-checkbox') {
            const uniqueNewValue = Array.isArray(newValue)
              ? newValue.filter(
                  (option, i, self) =>
                    i ===
                    self.findIndex(o => o.unique_key === option.unique_key),
                )
              : [];

            selectedWithOriginalGroups = uniqueNewValue.map(option => ({
              ...option,
              selected: true,
              group: isGrouped ? [option.group] : option.group,
            }));
            setHasValue(uniqueNewValue.length > 0);
          } else {
            selectedWithOriginalGroups = newValue
              ? { ...newValue, selected: true }
              : newValue;
            setHasValue(Boolean(newValue));
          }

          onFilterValueUpdated(filter, selectedWithOriginalGroups);
        }}
      />
      <label className="floating-label" htmlFor={inputId} key={labelText}>
        {labelText}
      </label>
    </div>
  );
};

export default AutocompleteDropdown;
